export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'
export const APP_VERSION = '1.0.0'
